'use client'

import React from 'react'
import {useTranslations} from 'next-intl'
import {css, useTheme} from '@emotion/react'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'

import SettingsControl from '../../modules/SettingsControl'


export default function ToolBaseMobileLayout({toolInfo, children}) {
  const theme = useTheme()
  const styles = {
    settings: css`
      position: fixed;
      top: 12px;
      right: 12px;
    `,

    headerWrapper: css`
      margin-bottom: 8px;
      overflow: hidden;
    `,

    titleContainer: css`
      width: 100%;
      background: transparent;
      cursor: pointer;
      margin-bottom: 8px;
      
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      &:hover {
        background-image: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
      }
    `,

    title: css`
      color: ${theme.palette.onPrimary.dark};
      font-size: 1.5em;
      font-weight: 700;
      margin: unset;
    `,

    descriptionContainer: css`
      transition-property: max-height;
      transition-duration: 250ms;
      transition-timing-function: ease-in-out;
    `,

    description: css`
      font-size: 1.2rem;
    `,

    content: css`
      flex: 1;
      position: relative;
    `,
  }

  const t = useTranslations()

  const [descriptionOpen, setDescriptionOpen] = React.useState(true)
  const onDescriptionButtonClick = () => {
    setDescriptionOpen(state => !state)
  }

  return (
    <>
      {/* 設定不需要爬蟲抓取 */}
      <div css={styles.settings} data-nosnippet={true}>
        <SettingsControl icon/>
      </div>

      <header id="header">
        <div css={styles.headerWrapper}>
          <div css={styles.titleContainer} onClick={onDescriptionButtonClick}>
            <h1 id="title" css={styles.title}>{t(`${toolInfo.key}.title`)}</h1>

            <KeyboardArrowUpIcon
              css={css`
                font-size: 2rem;
                transition: 250ms ease-in-out;
              `}
              style={{
                rotate: descriptionOpen ? '180deg' : '0deg'
              }}
            />
          </div>

          <div
            css={styles.descriptionContainer}
            style={{
              maxHeight: descriptionOpen ? 400 : 0,
            }}
          >
            <div css={styles.description}>{t(`${toolInfo.key}.description`)}</div>
          </div>
        </div>
      </header>

      {/* 內容不需要爬蟲抓取 */}
      <div css={styles.content} data-nosnippet={true}>
        {children}
      </div>
    </>
  )
}
